import React from 'react';
import BtnPreviousPath from '../components/btn-previous-path';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TitleGrows from "../components/title-grows";

export default function Info() {

  return (
    <>
      <TitleGrows txtTitle={'Info'} />
      <main style={{ padding: "1rem 0", overflow: "auto" }}>
        <div className="container-fluid" style={{ float: "left", minHeight: "46px" }}>

          <h6 style={{ textAlign: "center", margin: "30px" }}>
            Questa pagina è una pagina di test che non necessita del login per essere aperta
            <br></br>
            Può essere utile per fornire delle informazioni all'utente o per inserire una guida di utilizzo del cms
          </h6>

          <div className="row">
            <div className="col-12 col-md-12 col-lg-6 col-xl-6" style={{ textAlign: "center" }}>
              <BtnPreviousPath></BtnPreviousPath>
            </div>
            <div className="col-12 col-md-12 col-lg-6 col-xl-6" style={{ textAlign: "center" }}>
              <Link to="/login">
                <button type="button" className="btn btn-primary" style={{ width: "12rem" }}>
                  <FontAwesomeIcon icon={['fas', 'user']} size={'2x'} color={'white'} />
                  <span style={{ margin: "8px", verticalAlign: "super" }}>Vai a Login</span>
                </button>
              </Link>
            </div>
          </div>
        </div>

      </main>
    </>
  )
}